import React, { Component } from 'react';
import CakeSpinner from './Spinner';

export default class LoadingModal extends Component {
  render() {
    return <CakeSpinner classes="pt-3" />;
  }
}
